import React from 'react';
import { useTheme, SxProps, Theme } from '@mui/material';
import DSButton from './DSButton';
import { DSTitleTypography } from './Typography';
import DSBox from './DSBox';

type DSDrawerTabButtonProps = {
  title: string;
  startIcon?: React.ReactNode;
  isSelected?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  sx?: SxProps<Theme>;
  showNotification?: boolean;
};

const DSDrawerTabButton = ({
  title,
  startIcon,
  isSelected = false,
  disabled = false,
  onClick,
  sx,
  showNotification = false,
}: DSDrawerTabButtonProps) => {
  const { palette, spacing } = useTheme();

  const icon = startIcon ? (
    <DSBox sx={{ position: 'relative', display: 'flex' }}>
      {startIcon}
      {showNotification && (
        <DSBox
          sx={{
            position: 'absolute',
            top: -3,
            right: -3,
            width: 8,
            height: 8,
            borderRadius: '50%',
            backgroundColor: palette.error.main,
            pointerEvents: 'none',
          }}
        />
      )}
    </DSBox>
  ) : undefined;

  return (
    <DSButton
      onClick={onClick}
      startIcon={icon}
      disabled={disabled}
      disableRipple
      sx={{
        ...sx,
        justifyContent: 'flex-start',
        gap: spacing(2),
        width: '100%',
        textTransform: 'none',
        px: spacing(5),
        py: spacing(2),
        borderRadius: spacing(12),
        backgroundColor: 'transparent',
        color: isSelected ? palette.text.primary : palette.text.secondary,
        '&:hover': {
          backgroundColor: palette.white[8],
        },
        '&:focus': {
          backgroundColor: 'transparent',
        },
        transition: 'background-color 0.2s ease',
      }}
    >
      <DSTitleTypography
        textAlign={'left'}
        color={disabled ? palette.text.disabled : undefined}
      >
        {title}
      </DSTitleTypography>
    </DSButton>
  );
};

export default DSDrawerTabButton;
